import {
  Autocomplete,
  Checkbox,
  TextField,
} from "@mui/material";

interface LabelSelectProps {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
  loading?: boolean;
}

const LabelSelect = ({
  options,
  value,
  onChange,
  loading = false,
}: LabelSelectProps) => (
  <Autocomplete
    multiple
    freeSolo
    disableCloseOnSelect
    loading={loading}
    options={options}
    value={value}
    onChange={(_, nextValue) =>
      onChange(Array.from(new Set(nextValue.map((label) => label.trim()).filter(Boolean))))
    }
    renderOption={(props, option, state) => (
      <li {...props} key={option}>
        <Checkbox checked={state.selected} sx={{ mr: 1 }} />
        {option}
      </li>
    )}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        label="Labels"
        placeholder="Search or add a label"
        helperText="Select known labels or type a new one and press Enter"
      />
    )}
  />
);

export default LabelSelect;
